import React from 'react';
import { Link } from 'react-router';
import { Banner, Layout, Paragraph, ParagraphHeader } from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';

export type EngagementsViewStateBannerSubmittedProps = {
  engagement: CandidateEngagementDetails;
  name?: string;
};

export const EngagementsViewStateBannerSubmitted: React.FC<
  EngagementsViewStateBannerSubmittedProps
> = ({ engagement, name = 'ENGAGEMENTS_VIEW_STATE_BANNER_SUBMITTED' }) => {
  return (
    <Banner name={name} type="critical" impact="high">
      <Layout direction="vertical" verticalGutter="24px">
        <ParagraphHeader name="SUBMITTED_HEADER">
          Next Step: Client review
        </ParagraphHeader>
        <Paragraph name="SUBMITTED_MESSAGE_1">
          Your profile has been submitted for the client's consideration. No
          need to contact us for updates, as we have the same information you
          see here.
        </Paragraph>
        <Paragraph name="SUBMITTED_MESSAGE_2">
          To make scheduling quick and easy for the client, provide plenty of
          open spots on your{' '}
          <Link
            to="../../profile/interview-availability"
            data-test="INTERVIEW_LINK"
          >
            interview availability calendar
          </Link>
          .
        </Paragraph>
      </Layout>
    </Banner>
  );
};
